import React from "react";
import { Link } from "react-router-dom";

export default function WearWithIt() {

  const wearItems = [
    {
      img: "/images/picksforyou/2.png",
      title: "Classic T-Shirt",
      price: 799,
      colors: ["#000", "#555", "#b83232"],
      slug: "classic-t-shirt"
    },
    {
      img: "/images/picksforyou/3.png",
      title: "Sports Jacket",
      price: 1999,
      colors: ["#222", "#666", "#0a58ca"],
      slug: "sports-jacket"
    }
  ];

  return (
    <div className="container mt-5">
      <h4
        style={{
          fontFamily: "'Figs','Raleway',sans-serif",
          fontWeight: "700",
          marginBottom: "25px",
          fontSize:"28px",
          lineHeight:"1.5",
          letterSpacing:"0.05em",
          
        }}
      >
        Wear With It
      </h4>

      <div className="row g-4">
        {wearItems.map((item, index) => (
          <div
            key={index}
            className="col-lg-12"
            style={{
              borderTop: "1px solid #eee",
              borderBottom: "1px solid #eee",
              padding: "20px",
              borderRadius: "12px",
              margin:"20px 0px"
            }}
          >
            <div className="row align-items-center">

              {/* LEFT - IMAGE + TITLE + PRICE */}
              <div className="col-md-4 d-flex align-items-center gap-3">
                  <Link to={`/product/${item.slug}`}  style={{ textDecoration: "none", color: "inherit" }}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="img-fluid rounded"
                  style={{
                    width: "110px",
                    height: "110px",
                    objectFit: "cover"
                  }}
                />
                </Link>

                <div>
                  <Link to={`/product/${item.slug}`}  style={{ textDecoration: "none", color: "inherit" }}>
                  <h6
                    style={{
                      marginBottom: "6px",
                      fontWeight: 600,
                      fontFamily: "'Figs','Raleway',sans-serif"
                    }}
                  >
                    {item.title}
                  </h6>
                  </Link>

                  <p
                    style={{
                      margin: 0,
                      fontSize: "15px",
                      color: "#555",
                      fontWeight: 600
                    }}
                  >
                    ₹{item.price}
                  </p>
                </div>
                
              </div>

              {/* CENTER - COLORS + SIZE CHART */}
              <div className="col-md-4">
                <h6
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    marginBottom: "8px"
                  }}
                >
                  COLORS
                </h6>

                <div className="d-flex gap-2 mb-3">
                  {item.colors.map((clr, idx) => (
                    <div
                      key={idx}
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: clr,
                        border: "2px solid #ddd",
                        cursor: "pointer"
                      }}
                    />
                  ))}
                </div>

               <div className="d-flex flex-wrap gap-2 mt-2">
        {["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL"].map((size) => (
          <div
            key={size}
            style={{
              width: "38px",
              height: "38px",
              border: "1px solid rgb(204,204,204)",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              fontWeight: "600",
              cursor: "pointer",
              userSelect: "none",
              padding:"0 8px"
            }}
          >
            {size}
          </div>
        ))}
      </div>
              </div>

             

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
